import { createAction } from 'redux-actions';
import * as types from './types';

export const setSubCommunities = createAction(types.SET_SUB_COMMUNITIES);
export const setSubCommunitiesToJoin = createAction(types.SET_SUB_COMMUNITIES_TO_JOIN);
export const removeSubCommunity = createAction(types.REMOVE_SUB_COMMUNITY);
